import { useQuery } from 'react-query';

import { getCacheSettings } from 'common/helpers';
import { QUERY_KEYS } from 'consts/queryKeys';
import { getCooperationTypes } from 'modules/_common/api';

export const useQueryCooperationTypes = () => {
  const {
    data: cooperationTypes,
    isLoading: cooperationTypesIsLoading,
    isError: cooperationTypesIsError,
  } = useQuery(QUERY_KEYS.RENTALS_COOPERATION_TYPES, getCooperationTypes, getCacheSettings());

  return { cooperationTypes, cooperationTypesIsLoading, cooperationTypesIsError };
};
